import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=c42ae8ba&lang=pug&"
import script from "./Dashboard.vue?vue&type=script&lang=coffee&"
export * from "./Dashboard.vue?vue&type=script&lang=coffee&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports